export default "__VITE_ASSET__bxI2Ob39__"